import React, { useEffect, useState } from "react";
// import Header from "./Header/Header";
// import { ReactComponent as CloseIcon } from "../../../../assets/svg/close.svg";
import Scrollbars from "react-custom-scrollbars";
import InsightsTabComponent from "./Header/InsightsTabComponent";
import ReadTab from "./ReadTab";
import SavedTab from "./SavedTab";
// import EmptyPage from "./EmptyPage";
import { ReactComponent as SettingsIcon } from "../../../../assets/svg/settings.svg";
import Settings from "./Settings/Settings";
import { useDispatch, useSelector } from "react-redux";
import Icon from "semantic-ui-react/dist/es/elements/Icon";
import { switchMainTab, cleanupData, minimizeInsightsTab } from "../../../../actions/insightsRecommendationActions";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { ReactComponent as MinimizeIcon } from "../../../../assets/svg/minimize-icon.svg";

const InsightsHomePage = (props) => {
    const dispatch = useDispatch();
    // const { currentPage, closeInsights } = props;
    const brandTopicObj = useSelector((state) => state.insightsRecommendationReducer.ownBrand);
    const competitorTopicObj = useSelector((state) => state.insightsRecommendationReducer.competitorsBrand);

    // useEffect(() => {
    //     dispatch(getConfigRecommendationFilterList());
    // }, []);

    useEffect(() => {
        // if (brandTopicObj || competitorTopicObj) {
        //     setIsConfigured(true);
        // }
        if (!brandTopicObj && !competitorTopicObj) {
            setIsSettingsActive(true);
        }
    }, [brandTopicObj, competitorTopicObj]);
    const getcurrentTab = {
        Insights: InsightsTabComponent,
        Saved: SavedTab,
        Read: ReadTab,
    };

    const [tab, setTab] = useState("Insights"); //can Read, Saved Tab too
    const Component = getcurrentTab[tab];
    // const [isConfigured, setIsConfigured] = useState(false);
    const [isSettingsActive, setIsSettingsActive] = useState(false);

    const toggleSettings = () => {
        setIsSettingsActive((prev) => !prev);
    };

    const switchToHelpTab = () => {
        dispatch(cleanupData());
        dispatch(switchMainTab("help"));
    };

    const minimizeTab = () => {
        dispatch(switchMainTab("home"));
        setTimeout(() => {
            dispatch(minimizeInsightsTab(true));
        }, 300);
    };
    return (
        <>
            <div className="insights__home__page">
                <div className="top__section">
                    <div className="minimize__icon" onClick={minimizeTab}>
                        <MinimizeIcon />
                    </div>

                    <div className="heading__block no__margin">
                        <div className="left">
                            <div className="insights__heading genie">
                                Insights Genie <span className="top__content">Beta</span>
                            </div>
                            {/* <div className="secondary__content">Generative AI-powered insights from your own data!</div> */}
                        </div>
                        <div className="right">
                            <Popup
                                content="Info"
                                inverted
                                size="mini"
                                trigger={<Icon className="help__icon" name="help circle" onClick={switchToHelpTab} />}
                                position="top center"
                            />
                            <Popup
                                content="Settings"
                                inverted
                                size="mini"
                                trigger={<SettingsIcon onClick={toggleSettings} className={`settings__icon ${isSettingsActive ? "active" : ""}`} />}
                                position="top center"
                            />
                        </div>

                        {/* <CloseIcon className="close__icon" onClick={closeInsights} /> */}
                    </div>
                    <div className="lower__section">
                        <p>Generative AI-powered insights from your own data!</p>
                    </div>
                </div>
                <div className="main__content__wrapper">
                    {isSettingsActive ? <Settings closeSettings={toggleSettings} /> : null}
                    {/* {isConfigured ? ( */}

                    <Scrollbars>{<Component setPageChange={props.setPageChange} pageChange={props.pageChange} />}</Scrollbars>
                    {/* ): (
                        <EmptyPage />
                    )} */}
                </div>
            </div>
        </>
    );
};

export default InsightsHomePage;
